<div class="loader" role="status" aria-live="polite">
  <img
    src="/assets/images/icons/logo-spinner.gif"
    alt="Loading"
    class="loader__spinner"
  />
  <p class="loader__text">
    {{ 'common.loading' | translateLang }}
  </p>
</div>
